import { combineReducers } from 'redux';

import curriculum from './reducers/foodTruckCurriculumReducer';
import navigation from './reducers/foodTruckNavigationReducer';
import question from './reducers/foodTruckQuestionReducer';
import animation from './reducers/foodTruckAnimationReducer';
import audioSequence from './reducers/foodTruckAudioSequenceReducer';
import goblin from './reducers/foodTruckGoblinReducer';
import alex from './reducers/foodTruckAlexReducer';
import gameDetails from './reducers/foodTruckGameDetailsReducer';
import standardRound from './reducers/foodTruckStandardRoundReducer';

export default combineReducers({
  curriculum,
  navigation,
  question,
  animation,
  audioSequence,
  goblin,
  alex,
  gameDetails,
  standardRound,
});
